import { GridItemsHeight } from "@multiweb/reactComponents";
import { LocalizationItem } from "@multiweb/reactCore/i18n/dev";
import { IconCode } from "@multiweb/types/contracts";
import { ActionType, IOrderBy, OrderType } from "@multiweb/types/multiweb";
import { ReactAction, TypedObject } from "@multiweb/types/react";
import { EMPTY_ARRAY } from "../constants";
import { createSequenceArray } from "../create";
import { getNthItem } from "./methods";
import { GridItemOptions } from "./types";

/**
 * Vytvoří akce na základě zadaných počtů.
 * @param actionsCount Počet akcí s klasickým tlačítkem.
 * @param iconActionsCount Počet akcí s ikonovým tlačítkem.
 * @param locItems Mapa lokalizací k akcím.
 */
export const createMockReactActionArray = (
    actionsCount: number,
    iconActionsCount: number,
    locItems?: TypedObject<LocalizationItem>,
): ReactAction[] => {
    const locKeys = locItems ? Object.keys(locItems) : EMPTY_ARRAY;
    return createSequenceArray(actionsCount + iconActionsCount).map((index) => ({
        id: index.toString(),
        locKey: getNthItem(locKeys, index),
        text: "TextButton",
        iconCode: index >= actionsCount ? IconCode.editorialPencil : undefined,
        actionType: ActionType.method,
        enabled: true,
        enabledVisual: true,
        order: index + 1,
        priority: actionsCount + iconActionsCount - index,
        visible: true,
        isActive: true,
    }));
};

/**
 * Vytvoří pole typu *GridItemOptions* o zadané délce.
 * @param length Požadovaná velikost pole.
 * @param gridItemsHeight Určuje, zdali si položky GridLayoutu zachovají výšku z definice (keepHeight), nebo se roztáhnou na výšku řádku.
 */
export const createGridItemOptionsArray = (length: number, gridItemsHeight?: GridItemsHeight): GridItemOptions[] => {
    const gridItemOptions: GridItemOptions[] = [];
    for (let i = 0; i < length; i++) {
        gridItemOptions.push({ gridItemsHeight, order: i });
    }
    return gridItemOptions;
};

/**
 * Vytvoří typ pro řazení podle zadaných atributů.
 * @param attributes Atributy pro řazení oddělené středníkem (např.: attr0;DESC attr1;attr2).
 */
export const createOrderBy = (attributes: string): ReadonlyArray<IOrderBy> =>
    attributes
        .split(";")
        .filter((att) => att !== "")
        .map((attr) => {
            let order: OrderType = OrderType.ascending;
            let attributeName = attr;
            const splitedOrder = attr.split(" ");
            if (splitedOrder.length === 2) {
                attributeName = splitedOrder[1];
                if (splitedOrder[0].toUpperCase() === "DESC") {
                    order = OrderType.descending;
                }
            }
            return {
                attributeName,
                order,
            };
        });
